export default "__VITE_PUBLIC_ASSET__6011c98a__"